import React from 'react';

interface RankedData {
  queueType: string;
  tier: string;
  rank: string;
  leaguePoints: number;
  wins: number;
  losses: number;
}

interface RankedInfoProps {
  label: string;
  data?: RankedData;
}

const TIER_COLORS: Record<string, string> = {
  IRON: '#6b6b6b',
  BRONZE: '#a0715e',
  SILVER: '#8c9aab',
  GOLD: '#c9aa71',
  PLATINUM: '#2c9c8f',
  EMERALD: '#2daf6e',
  DIAMOND: '#576bce',
  MASTER: '#9d48e0',
  GRANDMASTER: '#e34343',
  CHALLENGER: '#f4c874',
};

const RankedInfo: React.FC<RankedInfoProps> = ({ label, data }) => {
  if (!data) {
    return (
      <div className="ranked-card">
        <h3 className="ranked-label">{label}</h3>
        <p className="ranked-unranked">Unranked</p>
      </div>
    );
  }

  const tierFormatted = data.tier.charAt(0) + data.tier.slice(1).toLowerCase();
  const winRate = Math.round((data.wins / (data.wins + data.losses)) * 100);
  const tierColor = TIER_COLORS[data.tier] || '#ffffff';

  return (
    <div className="ranked-card">
      <h3 className="ranked-label">{label}</h3>
      <div className="ranked-tier" style={{ color: tierColor }}>
        {tierFormatted} {data.rank}
      </div>
      <div className="ranked-lp">{data.leaguePoints} LP</div>
      <div className="ranked-record">
        <span className="ranked-wins">{data.wins}W</span>
        {' '}
        <span className="ranked-losses">{data.losses}L</span>
        {' '}
        <span className="ranked-winrate">({winRate}% WR)</span>
      </div>
    </div>
  );
};

export default RankedInfo;
